<template>
  <v-dialog v-model="visibility" persistent max-width="438px">
    <v-card v-if="visibility" class="rounded-xl py-2">
      <v-card-title class="pt-6 px-6 pb-0">
        <v-icon color="#828282" size="32">mdi-cog-pause</v-icon>
      </v-card-title>

      <!-- Title -->
      <v-card-title class="pa-6">
        <h4 class="text-capitalize dialog-title">{{ t('$vuetify.__Approval.wait_approval_dialog.title') }}</h4>
      </v-card-title>

      <!-- Hint -->
      <v-card-text class="approval-hint-text">{{ t('$vuetify.__Approval.wait_approval_dialog.hint') }}</v-card-text>

      <!-- Changed by -->
      <v-card-text class="submitted-by-text pb-8">
        <v-row no-gutters align="baseline">
          {{ t('$vuetify.__Approval.wait_approval_dialog.submitted_by') }}
          <v-icon size="18" class="ml-2 mr-1">mdi-account</v-icon>
          {{ item?.pending_approval.submitted_by.username }}
        </v-row>
      </v-card-text>

      <!-- Action buttons -->
      <v-card-actions class="px-6 py-4">
        <v-spacer></v-spacer>
        <v-btn variant="outlined" rounded :disabled="submit_btn_disable" class="text-capitalize px-3" @click="store.commit('RESET_WAIT_APPROVAL_DIALOG')">
          {{ t('$vuetify.__General.back') }}
        </v-btn>
        <v-btn
          v-if="item?.can_cancel"
          variant="flat"
          color="#CF321D"
          rounded
          :dark="!submit_btn_disable"
          :disabled="submit_btn_disable"
          class="text-capitalize px-3"
          @click="store.dispatch('cancelChangesSubmission')"
        >
          {{ t('$vuetify.__Approval.wait_approval_dialog.cancel_submission') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'
import { useLocale } from 'vuetify'
const { t } = useLocale()
import { useStore } from 'vuex'
const store = useStore()

const submit_btn_disable = computed(() => store.state.waitApprovalDialog.submit_btn_disable)
const visibility = computed(() => store.state.waitApprovalDialog.visibility)
const item = computed(() => store.state.waitApprovalDialog.item)
</script>

<style scoped>
.approval-hint-text {
  color: #211f20 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  letter-spacing: 0.1px !important;
}

.submitted-by-text {
  color: #626262 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  letter-spacing: 0.1px !important;
}
</style>
